// src/hooks/useKoelcelConfig.js
import { useEffect, useMemo, useState } from "react";
import {
  db,
  doc,
  getDoc,
  onSnapshot,
  setDoc,
  serverTimestamp,
} from "../services/firestore.js";

const DEFAULT = { aflevercel: false, cor: false };

export default function useKoelcelConfig({ orgId, enabled = true } = {}) {
  const [loading, setLoading] = useState(false);
  const [extraKoelcellen, setExtraKoelcellen] = useState(DEFAULT);

  useEffect(() => {
    if (!enabled || !orgId) return;

    let cancelled = false;
    let unsub = null;

    setLoading(true);

    const ref = doc(db, "orgs", orgId, "config", "ui");

    (async () => {
      try {
        // 1) Provision: maak het doc éénmalig aan als het nog niet bestaat
        const snap = await getDoc(ref);
        if (!snap.exists()) {
          await setDoc(
            ref,
            { extraKoelcellen: DEFAULT, updatedAt: serverTimestamp() },
            { merge: true }
          );
        }

        if (cancelled) return;

        // 2) Pas daarna: realtime listener (read-only)
        let first = true;
        unsub = onSnapshot(
          ref,
          (s) => {
            const data = s.data() || {};
            const extra = data.extraKoelcellen || {};

            setExtraKoelcellen({
              aflevercel: !!extra.aflevercel,
              cor: !!extra.cor,
            });

            if (first) {
              first = false;
              setLoading(false);
            }
          },
          () => {
            // listener error (bijv. offline), loading uit
            setLoading(false);
          }
        );
      } catch (e) {
        setLoading(false);
        // optioneel: console.error(e);
      }
    })();

    return () => {
      cancelled = true;
      if (typeof unsub === "function") unsub();
    };
  }, [orgId, enabled]);

  return useMemo(() => ({ extraKoelcellen, loading }), [extraKoelcellen, loading]);
}
